import { useFragment } from "@apollo/client";
import { useMemo } from "react";
import GatheringForCommentsThreadThemeFragmentFragmentDoc from "src/api/graphql/__generated__/documents/GatheringForCommentsThreadThemeFragmentFragmentDoc";
import parseStickerTemplateUrl from "src/helpers/parseV0TemplateUrl/parseStickerTemplateUrl";

const useGatheringCommentsThreadThemeFragment = ({ gatheringId }: { gatheringId: string }) => {
	const { data } = useFragment({
		fragment: GatheringForCommentsThreadThemeFragmentFragmentDoc,
		fragmentName: "GatheringForCommentsThreadThemeFragment",
		from: {
			__typename: "Gathering",
			gatheringId: gatheringId,
		},
		optimistic: true,
	});
	const result = useMemo(() => {
		const result: {
			palette?: {
				primary: string;
				secondary: string;
				tertiary: string;
			};
			stickers?: {
				url: string;
			}[];
		} = {};
		if (
			data?.palette &&
			data.palette.primary &&
			data.palette.secondary &&
			data.palette.tertiary
		) {
			result.palette = {
				primary: data.palette.primary,
				secondary: data.palette.secondary,
				tertiary: data.palette.tertiary,
			};
		}
		if (data?.stickerPack && data.stickerPack.stickers) {
			const stickers: { url: string }[] = [];
			for (const sticker of data.stickerPack.stickers) {
				const imageUrl = parseStickerTemplateUrl({
					readUrl: sticker?.readUrl,
				});
				if (imageUrl) {
					stickers.push({ url: imageUrl });
				}
			}
			if (stickers.length > 0) {
				result.stickers = stickers;
			}
		}
		return result;
	}, [data]);
	return result;
};
export default useGatheringCommentsThreadThemeFragment;
